import React from 'react';
import { useSettings } from '@apollo/core';
import FormCom from '../../../../shared/components/Form/FormCom';

const DefaultPaymentForm = ({
  selectedPayment,
  depositForm,
  confirmationHandler,
  submitHandler,
}) => {
  const { isCordova, platform } = useSettings();
  return (
    <div className='row payments-list__default'>
      <FormCom
        form={depositForm}
        additionalValues={{
          pmId: selectedPayment.paymentId || selectedPayment.id,
          isCordova: isCordova.toString(),
          platform: platform?.toLowerCase() || 'browser',
        }}
        action={confirmationHandler}
        buttonText='deposit'
        onSubmit={submitHandler}
      />
    </div>
  );
};

export default DefaultPaymentForm;
